module.exports = __webpack_public_path__ + "static/media/20201129_200432_767_IMG_1771.fbbc20df.jpg";